import React from 'react';
import {Router, hashHistory, Route} from 'react-router';
import App from './components/App';
import auth from './libs/auth';
import Login from './components/Login';
import EntryTable from './components/EntryTable';

function requireAuth(nextState, replace) {
  if (!auth.loggedIn()) {
    delete window.localStorage.token;
    replace({
      pathname: '/login',
      state: {nextPathname: nextState.location.pathname}
    });
  }
}

function redirectIfAuthenticated(nextState, replace) {

  if (auth.loggedIn()) {
    replace({
      pathname: '/',
      state: {nextPathname: nextState.location.pathname}
    });
  }
}

function logOut(nextState, replace) {
  delete window.localStorage.clear();
  replace({
    pathname: '/login',
    state: {nextPathname: nextState.location.pathname}
  });
}

const NotFound = () => (
  <div className="spinner">
    <img className="img-responsive" src="http://azuretwilight.org/filedata/fetch?id=222" alt="not found"/>
  </div>
);

const Routes = () => (
  <Router history={hashHistory}>
    <Route path="/login" component={Login} onEnter={redirectIfAuthenticated}/>
    <Route path="/logout" onEnter={logOut}/>
    <Route path='/' component={App} onEnter={requireAuth}>
      <Route path="dataSource">
        <Route path=":dataOriginId/:dataSourceId" component={EntryTable}/>
      </Route>
      <Route path="*" component={NotFound}/>
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js